import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
import { combineDucks } from "../helpers/combineDucks";
import { createActionDuck } from "../helpers/action";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, } from "./updateNotification";
import { Observable } from "rxjs";
const getTimeConfigUrl = () => {
    return `/api/v1/time/config`;
};
const computeTimeConfigId = () => {
    return `time_config`;
};
export const getTimeConfig = createItemFetcher(getTimeConfigUrl, "TIME_CONFIG", computeTimeConfigId);
export const createTimeConfig = () => getTimeConfig;
function updateTimeConfig(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.FINISH)
        .mergeMap(() => Observable.of(getTimeConfig.actions.fetchItem(undefined)));
}
export const useGetTimeConfig = createUseFetch(getTimeConfig, (state) => state.clockConfig.getTimeConfig);
const getTimeLeapsUrl = () => {
    return `/api/v1/time/leaps`;
};
const computeLeapsId = () => {
    return `time_leaps`;
};
export const getTimeLeaps = createItemFetcher(getTimeLeapsUrl, "TIME_LEAPS", computeLeapsId);
export const createTimeLeaps = () => getTimeLeaps;
export const useGetTimeLeaps = createUseFetch(getTimeLeaps, (state) => state.clockConfig.getTimeLeaps);
const computeTimeConfigPost = () => {
    const url = `/api/v1/time/config`;
    return {
        method: "POST",
        url,
    };
};
export const timeConfigPost = createActionDuck("TIME_CONFIG_POST", computeTimeConfigPost, computeTimeConfigId);
timeConfigPost.middleware.push(createNotificationOnCreateEpic(timeConfigPost.ActionKeys), createNotificationOnCreateErrorEpic(timeConfigPost.ActionKeys), updateTimeConfig(timeConfigPost.ActionKeys));
export const clockConfig = combineDucks({
    getTimeConfig,
    getTimeLeaps,
    timeConfigPost,
});
//# sourceMappingURL=index.js.map